export const costCenterRoutes = [
  {
    path: '/configuracoes/centros-de-custo/:id?',
    name: 'CostCenters',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'config'
    },
    component: () => import(/* webpackChunkName: 'cost-centers-page' */ 'views/CostCentersPage')
  },
  {
    path: '/configuracoes/centro-de-custo/:type/:id?',
    name: 'CostCenter',
    meta: {
      requiresAuth: true,
      chat: true,
      path: 'config'
    },
    component: () => import(/* webpackChunkName: 'cost-center-page' */ 'views/CostCenterPage')
  }
]
